import { render, staticRenderFns } from "./planTable.vue?vue&type=template&id=0b4e2736&scoped=true"
import script from "./planTable.vue?vue&type=script&lang=js"
export * from "./planTable.vue?vue&type=script&lang=js"
import style0 from "./planTable.vue?vue&type=style&index=0&id=0b4e2736&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b4e2736",
  null
  
)

export default component.exports